// Przestrzeń nazw 'voices': biblioteka głosów, wybór głosu (drawer) i pole głosu.
//
// VERIFY: cały plik, brak w mockupie (mockup nie ma ekranu głosów asystenta).
export default {
  filters: {
    categoryPlaceholder: 'Kategoria',
    languagePlaceholder: 'Język',
    genderPlaceholder: 'Płeć',
  },
  // Klucze to wartości `category` z API (ElevenLabs).
  categories: {
    premade: 'Gotowe',
    cloned: 'Sklonowane',
    generated: 'Wygenerowane',
    professional: 'Profesjonalne',
    famous: 'Znane',
    high_quality: 'Wysoka jakość',
  },
  // Klucze to wartości `gender` z API.
  gender: {
    male: 'Męski',
    female: 'Żeński',
    neutral: 'Neutralny',
  },
  // Klucze to wartości `age` z API.
  age: {
    young: 'Młody',
    middle_aged: 'W średnim wieku',
    old: 'Starszy',
  },
  actions: {
    preview: 'Odsłuchaj',
    pause: 'Wstrzymaj',
    copyId: 'Kopiuj ID',
  },
  idCopied: 'Skopiowano ID głosu',
  empty: 'Nie znaleziono głosów. Zmień wyszukiwanie lub filtry.',
  libraryUnavailable:
    'Biblioteka głosów jest niedostępna. Skontaktuj się z administratorem, aby skonfigurować usługi głosowe.',
  field: {
    browse: 'Przeglądaj głosy',
    change: 'Zmień',
  },
  selector: {
    title: 'Wybierz głos',
    searchPlaceholder: 'Szukaj według nazwy, akcentu, opisu…',
    adding: 'Dodawanie głosu do konta…',
    loadError:
      'Nie udało się załadować głosów. Skontaktuj się z administratorem, aby skonfigurować usługi głosowe.',
    errors: {
      noCompany: 'Nie można dodać głosu – nie ustawiono firmy.',
      noVoiceId:
        'Nie udało się dodać głosu „{{name}}” do konta. Żądanie klonowania nie zwróciło voice_id. Wybierz inny głos.',
      // {{error}} to komunikat z backendu, zostaje bez tłumaczenia.
      addFailed: 'Nie udało się dodać głosu „{{name}}” do konta: {{error}}',
      unknown: 'Nieznany błąd',
    },
  },
} as const;
